import React from "react";
import withLocalization from "../../../hoc/with-localization";
import InputGroup from "./input-group/input-group";
import inputSettings from "../../../settings/params-settings";
const HRComponent = ({ loc, data: { HR }, onChanged }) => {
    const { min, max } = inputSettings.HR;
    return (
        <div className="ctrl-block">
            <div className="ctrl-input-group-hr">
                <InputGroup
                    {...{
                        id: "edit.HR",
                        title: loc("report.params.HR"),
                        val: HR,
                        units: loc("units.bpm"),
                        _key: "HR",
                        onChanged,
                        min,
                        max
                    }}
                />
            </div>
        </div>
    );
};

const RRComponent = ({ loc, data: { RRmin_ms, RRmax_ms }, onChanged }) => {
    const rrMinID = "edit.RRMin",
        rrMaxID = "edit.RRMax";
    return (
        <div className="ctrl-block">
            <div className="ctrl-input-group-hr">
                <label>RR</label>
                <input
                    type="number"
                    id={rrMinID}
                    className="ctrl-input"
                    min="0"
                    value={RRmin_ms}
                    onChange={e => onChanged(rrMinID, { RRmin_ms: +e.target.value })}
                />
                <span>-</span>
                <input
                    type="number"
                    id={rrMaxID}
                    className="ctrl-input"
                    min="0"
                    value={RRmax_ms}
                    onChange={e => onChanged(rrMaxID, { RRmax_ms: +e.target.value })}
                />
                <span className="ctrl-units">{loc("units.ms")}</span>
            </div>
        </div>
    );
};

const HRReact = props => {
    const {
        loc,
        data: { HR, RRmin_ms, RRmax_ms },
        onChanged
    } = props;
    return (
        <div className="ctrl-container ctrl-container-HR">
            <HRComponent loc={loc} data={{ HR }} onChanged={onChanged} />
            <RRComponent loc={loc} data={{ RRmin_ms, RRmax_ms }} onChanged={onChanged} />
        </div>
    );
};

export default withLocalization(HRReact);
